(function () {

  // ─── 1. NATIVE SELECTOR FIX ─────────────────────────────────────────────
  // Pumper button ka type="submit" → type="button" kar deta hai
  // Isse ProductForm.resetFormState() crash karta hai BEFORE fetch
  // Fix: whenDefined() se wait karo, phir null-safe patch lagao
  customElements.whenDefined('product-form').then(function () {
    var ProductFormClass = customElements.get('product-form');
    if (!ProductFormClass) return;

    var _orig = ProductFormClass.prototype.resetFormState;
    ProductFormClass.prototype.resetFormState = function () {
      try {
        _orig.call(this);
      } catch (e) {
        // submitButtonElement null hai (Pumper ki wajah se) — manually handle
        this.hasError = false;
        var btn = this.querySelector('[name="add"]');
        if (btn) btn.removeAttribute('aria-disabled');
        if (typeof this.displayFormErrors === 'function') this.displayFormErrors();
      }
    };
  });

  // ─── 2. PUMPER SELECTOR → GALLERY FIX ──────────────────────────────────
  // Pumper ke selects change hone pe theme ka pubsub fire nahi hota
  // Gallery ko directly sync karo

  var HANDLE = window.pmpr_product && window.pmpr_product.handle;
  if (!HANDLE) return;

  var cache = null;

  function loadCache(cb) {
    if (cache) return cb(cache);
    fetch('/products/' + encodeURIComponent(HANDLE) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        cache = {};
        (product.variants || []).forEach(function (v) {
          var key = v.option1 + '|' + v.option2 + (v.option3 ? '|' + v.option3 : '');
          cache[key] = v;
        });
        cb(cache);
      })
      .catch(function (e) { console.error('[PumperFix] product.js fetch failed', e); });
  }

  function getActiveSlot() {
    var checked = document.querySelector('input[class*="prvw_pair"]:checked');
    return checked ? parseInt(checked.value, 10) - 1 : 0;
  }

  function getFirstItemOptions(slot) {
    var selects = document.querySelectorAll('[id^="prvw_selector_' + slot + '_1"]');
    var opts = [];
    selects.forEach(function (s) { if (s.value) opts.push(s.value); });
    return opts;
  }

  function syncGallery() {
    var slot = getActiveSlot();
    var opts = getFirstItemOptions(slot);
    if (!opts.length) return;
    var key = opts.join('|');

    loadCache(function (c) {
      var variant = c[key];
      if (!variant || !variant.featured_media) return;

      document.querySelectorAll('[id^="MediaGallery-"]').forEach(function (gallery) {
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.init();
          gallery.setActiveMedia(variant);
        }
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.id) return;

    if (/^prvw_selector_\d+_/.test(e.target.id)) {
      setTimeout(syncGallery, 50);
      return;
    }

    if (/^cb\d+$/.test(e.target.id) && e.target.className.indexOf('prvw_pair') > -1) {
      setTimeout(syncGallery, 50);
    }
  }, true);

  loadCache(function () {});

})();